import React from 'react';

import svgSprite from '../../assets/icons/sprite/all-symbol.svg?raw';

const SvgSprite = () => {
	return <div dangerouslySetInnerHTML={{__html: svgSprite}} style={{display: 'none'}} />;
};

export default SvgSprite;
